<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Generer PDF
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent>
								<div class="form-groups">
									<div class="form-group">

										<div class="input-group">
											<label>
												Aftale
											</label>

											<select v-model="agreementID" ref="agreementid">
												<option v-if="agreements.length == 0" value="0">Ingen aftaler fundet</option>
												<option v-if="agreements.length > 1" value="0">Vælg aftale</option>
												<option v-for="(agreement, index) in agreements" :key="index" v-bind:value="agreement.id">
													{{ agreement.name }}
												</option>
											</select><span></span>
										</div>

										<div class="input-group" v-if="agreementID != 0">
											<label>
												Vælg flet type
											</label>
											<div class="buttons-group">
												<button class="small" :class="{ 'outline' : mergetype != 1}" ref="mergetypeblankbutton" @click.self="setMergeType(1)">Blank</button>
												<button class="small" :class="{ 'outline' : mergetype != 2}" ref="mergetypegroupbutton" @click.self="setMergeType(2)">Alle grupper</button>
												<button class="small" :class="{ 'outline' : mergetype != 3}" ref="mergetypegroupbutton" @click.self="setMergeType(3)">Gruppe</button>
												<button class="small" :class="{ 'outline' : mergetype != 4}" ref="mergetypepersonbutton" @click.self="setMergeType(4)">Person</button>
											</div>
										</div>


										<div class="input-group" v-if="agreementID != 0 && mergetype == 3">
											<label>
												Vælg gruppe
											</label>

											<select v-model="persongroupID" ref="persongroupid">
												<option v-if="persongroups.length == 0" value="0">Ingen grupper fundet</option>
												<option v-if="persongroups.length > 1" value="0">Vælg gruppe</option>
												<option v-for="(persongroup) in persongroups" v-bind:value="persongroup.id" v-bind:key="persongroup.id">
													{{ persongroup.name }}
												</option>
											</select><span></span>

										</div>

										<div class="input-group" v-if="agreementID != 0 && mergetype == 4">
											<label>
												Vælg person
											</label>

											<div class="input-search">
												<input type="search" placeholder="Find person" v-model="personsearchinput" ref="personsearch" /><i data-ic="Q"></i>

												<ul class="input-searchresult">
													<li v-for="(person) in filteredPersonsList" v-bind:value="person.id" v-bind:key="person.id" :data-personid="person.id" @click="selectPerson(person)">
														{{ person.name }}
														<div class="small faded">
															{{ person.info }}
														</div>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>

								<div class="feedback information" v-if="generationStarted && agreementID == 0">
									Generering af fil sat igang
								</div>

								<div class="divider"></div>
								<div class="buttons-group">
									<button type="button" @click.prevent="close" class="text">
										Tilbage
									</button>
									<button type="button" :disabled="!canGeneratePDF" @click.prevent="generatePDF">
										Generer PDF
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";
	import { appFeedbackStateEnum } from "@/app/enums/common";
	import { personTypeEnum } from "@/app/enums/common";

	export default {
		name: "GeneratePDF",
		data()
		{
			return {
				dialogTitle: "Generer PDF",
				generationStarted: false,
				customerID: 0,
				agreementID: 0,
				agreements: [],
				mergetype: 1,
				personID: 0,
				persons: [],
				personsearchinput: "",
				persongroupID: 0,
				persongroups: []
			}
		},
		async mounted()
		{
			this.setModalIsVisible()
			this.customerID = this.$route.params.customerid
			this.agreementID = this.$route.params.agreementid
			this.setAppAsBusyModal();

			// Get agreements
			let searchdata = { customerID: this.customerID, status: 0, period: 0 }
			var agreementsResult = await this.$store.dispatch(types.ACTION_GET_AGREEMENTS, searchdata);

			if (agreementsResult.status == 200)
			{
				this.agreements = agreementsResult.data

				if (this.agreements.length > 0 && (this.agreementID == 0 || !this.agreementID))
				{
					this.agreementID = this.agreements[0].id
				}

				this.setAppAsIdle()
			}
			else
			{
				this.setAppAsIdle()
				logError("PersonEdit.loadData() getAgreements", error)
				this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
				this.$router.push({ name: "CustomerAgreement", params: { customerid: this.customerID, agreementid: this.agreementID } })
			}
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		computed:
		{
			canGeneratePDF()
			{
				return (this.agreementID != 0 &&
					(
						this.mergetype == 1 ||
						this.mergetype == 2 ||
						(this.mergetype == 3 && this.persongroupID != 0) ||
						(this.mergetype == 4 && this.personID != 0)
					))
			},
			filteredPersonsList()
			{
				if (!this.persons || this.persons.length == 0)
				{
					return []
				}

				var persons = this.persons
				return persons.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.personsearchinput.toLowerCase());
					let info = data.info.toLowerCase().match(this.personsearchinput.toLowerCase());
					return name || info;
				});
			}
		},
		methods:
		{
			selectPerson(person)
			{
				this.generationStarted = false
				this.personID = person.id
				this.personsearchinput = person.name
				this.$refs.personsearch.setAttribute("value", person.name)
			},
			async generatePDF()
			{
				if (this.canGeneratePDF)
				{
					this.setAppAsBusyModal();
					var result = null

					// Blank
					if (this.mergetype == 1)
					{
						result = await this.$store.dispatch(types.ACTION_GENERATE_ORDERING_PDF_AGREEMENT, {
							agreementid: this.agreementID
						});
					}
					// All groups
					else if (this.mergetype == 2)
					{
						result = await this.$store.dispatch(types.ACTION_GENERATE_ORDERING_PDF_ALLPERSONGROUPS, {
							agreementid: this.agreementID
						});
					}
					// Specific group
					else if (this.mergetype == 3)
					{
						result = await this.$store.dispatch(types.ACTION_GENERATE_ORDERING_PDF_PERSONGROUP, {
							agreementid: this.agreementID,
							persongroupid: this.persongroupID
						});
					}
					// Specific person
					else if (this.mergetype == 4)
					{
						result = await this.$store.dispatch(types.ACTION_GENERATE_ORDERING_PDF_PERSON, {
							agreementid: this.agreementID,
							personid: this.personID
						});
					}

					if (result && (result.status == 200 || result.status == 201))
					{
						this.setAppAsIdle()
						this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)

						this.persongroupID = 0
						this.personID = 0
						this.personsearchinput = ""
						this.generationStarted = true
					}
					else if (result && result.response.status == 400 && result.response.data.ErrorCode == "SimilarJobIsAlreadyRunning")
					{
						alert("Det valgte dokument er allerede ved at blive genereret. Vent venligst indtil filen er færdig.");
						this.setAppAsIdle()
					}
					else
					{
						this.showErrorAlert("Der opstod en fejl ved generering af PDF. Opdater siden og prøv igen.");
						this.setAppAsIdle()
					}
				}
				else
				{
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					this.$router.push({ name: "CustomerShow", params: { customerid: this.customerID } })
				}
			},
			async setMergeType(type)
			{
				this.setComponentAsBusy()
				this.mergetype = type
				this.generationStarted = false

				if (type == 3 && this.persongroups.length == 0)
				{
					let data = { customerid: this.customerID, agreementid: this.agreementID }
					var response = await this.$store.dispatch(types.ACTION_GET_PERSONGROUPS, data);

					if (response.status == 200)
					{
						this.persongroups = response.data;
						this.setComponentAsIdle()
					}
					else
					{
						this.setAppAsIdle()
						logError("GeneratePDF.getgroups()", response.error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					}
				}
				else if (type == 4 && this.persons.length == 0)
				{
					var response = await this.$store.dispatch(types.ACTION_GET_PERSONS, { customerid: this.customerID, agreementid: this.agreementID, persontype: personTypeEnum.CHILD })

					if (response.status == 200)
					{
						this.persons = response.data;
						this.setComponentAsIdle()
					}
					else
					{
						this.setAppAsIdle()
						logError("GeneratePDF.getpersons()", response.error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					}
				}
			},
			close()
			{
				this.$router.push({ name: "Files", params: { customerid: this.customerID, agreementid: this.agreementID } })
			}
		}
	}
</script>